import axios from 'axios';
import Cookies from 'universal-cookie';

import { ClaimRewardApiResponse, DailyLoginCalendarResponse, HistoryApiResponse } from './dailyRewards.models';

import { CookiesKeys } from 'enums/cookies-keys.enum';

const csrfHeaders = () => ({
  'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
});

export const fetchCalendar = async (year: number, month: number): Promise<DailyLoginCalendarResponse> => {
  const { data } = await axios.get<DailyLoginCalendarResponse>('/api/v1/daily-login/calendar/', {
    params: { year, month },
    headers: csrfHeaders(),
  });
  return data;
};

export const claimDailyReward = async (): Promise<ClaimRewardApiResponse> => {
  const { data } = await axios.post<ClaimRewardApiResponse>('/api/v1/daily-login/claim/', null, {
    headers: csrfHeaders(),
  });
  return data;
};

export const fetchRewardHistory = async (page: number): Promise<HistoryApiResponse> => {
  const { data } = await axios.get<HistoryApiResponse>('/api/v1/daily-login/history/', {
    params: { page },
    headers: csrfHeaders(),
  });
  return data;
};
